import { render, staticRenderFns } from "./IM02.vue?vue&type=template&id=1774954e&scoped=true&"
import script from "./IM02.vue?vue&type=script&lang=js&"
export * from "./IM02.vue?vue&type=script&lang=js&"
import style0 from "./IM02.vue?vue&type=style&index=0&id=1774954e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774954e",
  null
  
)

export default component.exports